<template>
  <NavButton
    v-if="enableFaq"
    :label="label"
    btn-id="faq-button"
    icon="question"
    :image-src="imageSrc"
    :list="list"
    @click="click"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'

import { FAQ_CONFIG_KEY } from '@/constants'

const components = {
  NavButton,
}

const props = {
  list: Boolean,
}

@Component({ components })
export default class NavBtnFaq extends Vue.extend({ props }) {
  get enableFaq () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.faq.enabled
  }

  get label () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.faq.buttonName
  }

  get imageSrc () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.imageOrPreview(['config', FAQ_CONFIG_KEY, 'buttonIcon'])
  }

  click () {
    this.$bvModal.show('faq-modal')
  }
}

</script>
